import { ArtifactVersionRead } from './schemas'

/**
 * Get the GCS file path for a given artifact version.
 * @param artifactVersion The artifact version.
 * @param userId The user ID.
 * @returns The GCS file path.
 */
export function getArtifactVersionGCSPath(artifactVersion: ArtifactVersionRead, userId: string): string {
  return `users/${userId}/${artifactVersion.artifact_id}/${artifactVersion.id}.${artifactVersion.file_extension}`
}
